import './index.scss'
import rateHtml from './index.html'
import { parseDom, toHHmmss } from '../../utils/index'

/**
 * 跳转历史播放记录
 */
export default class JumpHistoryComponent {
  player = null
  currentTime = 0
  // 已经显示过了
  showed = false
  // 历史播放时间
  $history = 0
  /**
   * @constructor 跳转历史播放记录构造函数
   */
  constructor(history) {
    this.html = parseDom(rateHtml)
    this.$history = +history
    // this.$history = 10
  }

  createEl(el) {
    el && el.appendChild(this.html)
  }

  updateUI() {
    const currentTime = this.$history
    if (+currentTime) {
      var text = toHHmmss(currentTime * 1000)
    } else {
      text = ''
    }

    const el = this.html.querySelector('a')
    el instanceof HTMLElement && (el.innerText = text)
  }

  initEvents() {
    var timer
    document.addEventListener.call(this.html, 'click', evt => {
      const target = evt.target
      if (target instanceof HTMLAllCollection) {
        const text = target.innerText
        if (/d+/.test(text)) {
          this.jump(this.$history)
        } else {
          this.jump(0)
        }
      }
      window.clearTimeout(timer)
      timer = setTimeout(() => this.hide(), 300)
    })
  }

  ready(player) {
    this.player = player
    this.initEvents(player)
  }

  play() {
    if (this.$history > 0 && !this.showed) {
      this.jump(this.$history)
    }
  }

  seek(time) {
    const player = this.player
    return player && player.seek(time)
  }

  jump(time) {
    const backTime = 3
    const player = this.player
    const total = player && player.getDuration()
    const lasted = Math.min(time, Math.max(0, +total - backTime))
    console.log('lasted:', lasted, +total - backTime)

    this.seek(lasted)
    this.toVisible()
  }

  toVisible() {
    this.updateUI()
    this.showed = true
    setTimeout(() => {
      this.show()
      setTimeout(this.hide.bind(this), 3 * 1000)
    }, 300)
  }

  show() {
    document.body.removeAttribute.call(this.html, 'hidden')
  }

  hide() {
    document.body.setAttribute.call(this.html, 'hidden', true)
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/JumpHistoryComponent/index.js